import SecureConnectionDetails from './secure-connection-details'

export default SecureConnectionDetails
